<template>
  <filter-summary
    icon="item"
    title="商品分類"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ count }}{{ label }}</div>
    <div>
      <span v-if="excludeNonActive">実績なしを除外する</span>
    </div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品分類の分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    company: String,
    excludeNonActive: Boolean,
    selectMode: String,
    categories: {
      type: Array,
      default: () => [],
    },
    item: {
      items: {
        type: Array,
        default: () => [],
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    count() {
      if (this.selectMode === 'category') {
        return this.item.categories.length
      } else if (this.selectMode === 'item') {
        return this.item.items.length
      }
      return undefined
    },
    label() {
      if (this.selectMode === 'category') {
        return '分類'
      } else if (this.selectMode === 'item') {
        return '商品'
      }
      return undefined
    },
  },
}
</script>
